<template>
  <div v-if="showComponent">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      v-if="label"
      >{{label}} <small v-if="required">*</small></label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      :class="{ 'ml-2': help }"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
    />
    <lm-dropdown
      v-if="isEditableByPickedUser"
      class="float-right"
      :tooltip="!disableEditors ? 'Selecciona quién edita este campo' : null"
      template="user-list"
      @input="$emit('editor-change', $event)"
      :value="collaborator"
      :disabled="disableEditors"
      closeAfterPick
    >
      <div class="d-flex align-items-center gap-2">
        {{ collaborator.name || '' }}
        <a-icon type="edit" v-if="!disableEditors" />
      </div>
    </lm-dropdown>
    <a-modal v-model="visible" @ok="handleSaveContent" :okText="$t('confirm')" :cancelText="$t('cancel')" >
      <h4>{{ pickedProp }}</h4>
      <a-textarea
        :placeholder="$t('write_a_text_for_variable')"
        :value="vars[pickedProp]"
        :auto-size="{ minRows: 3, maxRows: 10 }"
        @input="text = $event.target.value"
      />
      <p v-if="suggestion" class="my-2">
        Esta variable tiene un campo de formulario vinculado, <br />
        ¿Deseas usar su valor <span class="text-primary clickable" @click="onAcceptSuggestion">{{ suggestion }}</span>?
      </p>
    </a-modal>

    <section
      v-html="renderContent"
      class="lm-reader-input"
      :class="{disabled: disabled}"
      :ref="`reader-container-${_uid}`"
      @click="handleClick"
    ></section>
  </div>

</template>

<script>
// Utils
import lmInputMixin from '@/mixins/lmInputMixin'

export default {
  mixins: [lmInputMixin],
  data () {
    return {
      visible: false,
      text: '',
      suggestion: '',
      pickedProp: '',
      vars: {},
      renderContent: '',
      varsRegex: /%([\w\sñáéíóú-]+)%/gi,
      valueWatcherCount: 0
    }
  },
  methods: {
    handleSaveContent () {
      this.vars[this.pickedProp] = this.text
      this.replaceVarContent()
      this.pickedProp = ''
      this.text = ''
      this.suggestion = ''
      this.input()
      this.visible = false
    },
    handleClick (e) {
      if (this.disabled) return
      const target = e.target.closest('[data-clickable]')
      if (target) {
        this.visible = true
        this.pickedProp = target.dataset.varName
        this.linkFormComponentToVarContent(target)
      }
    },
    linkFormComponentToVarContent (target) {
      const varName = target.dataset.varName
      if (this.context) {
        for (const key in this.context) {
          const formComponentName = key.split('_').slice(0, -1).join(' ')
          if (formComponentName.toLowerCase() === varName.toLowerCase()) {
            if (this.vars[this.pickedProp] === '') {
              this.suggestion = this.formComponentValue(this.context[key])
              // this.vars[this.pickedProp] = this.formComponentValue(this.context[key])
              // this.text = this.formComponentValue(this.context[key])
            }
          }
        }
      }
    },
    formComponentValue (value) {
      if (typeof value === 'string') return value
      if (typeof value === 'object' && !Array.isArray(value)) return value?.name || value?.text || ''
      return ''
    },
    onAcceptSuggestion () {
      this.text = this.suggestion
      this.handleSaveContent()
    },
    generateRenderReplacer (match) {
      const varName = match.replaceAll('%', '')
      const content = match
      return `
        <span
          data-clickable
          data-var-name="${varName}"
          class="reader-content-var empty-content-var clickable"
        >${content}</span>
      `
    },
    /**
     * Si encuentra en content el patrón data-clickable quiere decir que content
     * ya fue populado y no debe volver a popularse
     */
    contentHasAlreadyBeenPopulatedWithDataClickable (content) {
      return content.includes('data-clickable')
    },
    generateRenderContent (content) {
      const stringHtml = content.replace(
        this.varsRegex,
        this.generateRenderReplacer
      )
      this.renderContent = stringHtml
    },
    replaceVarContent () {
      const readerContainer = this.$refs[`reader-container-${this._uid}`]
      const nodes = readerContainer.querySelectorAll(`[data-var-name="${this.pickedProp}"]`)
      for (const node of nodes) {
        if (this.vars[this.pickedProp].trim() !== '' && this.vars[this.pickedProp].includes('\n')) {
          // Si no es un string vacio y tiene enters
          const paragraphs = this.vars[this.pickedProp].split('\n')
          const container = document.createElement('span')
          container.setAttribute('data-clickable', '')
          container.dataset.varName = this.pickedProp
          container.className = 'clickable'
          let i = 0
          for (const content of paragraphs) {
            const itemContainer = document.createElement('span')
            const br = document.createElement('br')
            if (content) {
              const span = document.createElement('span')
              span.className = 'reader-content-var'
              span.textContent = content
              itemContainer.className = 'mb-0'
              itemContainer.appendChild(span)
            }
            if (i < paragraphs.length - 1) {
              itemContainer.appendChild(br)
            }
            container.appendChild(itemContainer)
            i++
          }
          node.replaceWith(container)
        } else if (this.vars[this.pickedProp].trim() !== '') {
          // Si no es un string vacio
          const span = document.createElement('span')
          span.setAttribute('data-clickable', '')
          span.dataset.varName = this.pickedProp
          span.className = 'reader-content-var clickable'
          span.textContent = this.vars[this.pickedProp]
          node.replaceWith(span)
        } else {
          // Si es un string vacio volvemos a mostrar la variable para poder ser completada
          const span = document.createElement('span')
          span.setAttribute('data-clickable', '')
          span.dataset.varName = this.pickedProp
          span.className = 'reader-content-var empty-content-var clickable'
          span.textContent = `%${this.pickedProp}%`
          node.replaceWith(span)
        }
      }
    },
    getContentVars (content) {
      // Extraigo todas las %vars% que existan en content
      const vars = content.match(this.varsRegex)
      if (vars) {
        vars.forEach(name => {
          // Por cada var en vars le vacio el valor que pueda tener
          // asignado en this.vars
          const varName = name.replaceAll('%', '')
          this.vars[varName] = ''
        })
      }
    },
    input () {
      this.$nextTick(() => {
        const html = this.$refs[`reader-container-${this._uid}`]
        const stringHtml = html.innerHTML
        this.$emit('input', {
          html: stringHtml,
          vars: this.vars
        })
      })
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val) {
          this.valueWatcherCount++
          this.vars = val.vars || {}
          this.renderContent = val.html || ''
          if (!this.isOnPreviewMode && this.valueWatcherCount > 1) {
            // Esto es un fix que ocurre cuando el editor con variables se oculta
            // o muestra al estar asociado a un condicional
            // (https://app.clickup.com/t/85ztpuc1w)
            // El fix consiste en volver a popular el contenido de this.renderContent
            // solo si previamente no fue populado
            if (!this.contentHasAlreadyBeenPopulatedWithDataClickable(val.html)) {
              this.generateRenderContent(val.html)
            }
            return
          }
          if (this.isOnPreviewMode) {
            this.getContentVars(val.html)
            this.generateRenderContent(val.html)
            return
          }
          if (!this.isOnEditMode) {
            this.getContentVars(val.html)
            this.generateRenderContent(val.html)
            this.input()
          }
        }
      }
    }
  }
}
</script>

<style lang="sass">
  .lm-reader-input .reader-content-var
    padding: 0 3px
    margin: 0 1px
    background-color: #fff280
    border-radius: 4px
    transition: transform .2s ease-in-out

  .lm-reader-input .reader-content-var.empty-content-var
    background-color: #ffd280

  .lm-reader-input:not(.disabled) [data-clickable]:hover
    border-radius: 4px
    outline: 3px solid rgba(28,110,164,0.35)
    outline-offset: 2px

  .lm-reader-input.disabled .clickable
    cursor: initial !important

  .lm-reader-input
    ul li
      list-style: disc

    > * + *
      margin-top: 0.75em

    ul, ol
      padding: 0 1rem

    h1, h2, h3, h4, h5, h6
      line-height: 1.1

    pre
      background: #363636
      color: #fff
      font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace
      padding: 0.75rem 1rem
      border-radius: 0.5rem

      code
        color: inherit
        padding: 0
        background: none
        font-size: 1rem

    img
      max-width: 100%
      height: auto

    blockquote
      padding-left: 1rem
      border-left: 2px solid rgba(13, 13, 13, 0.1)

    hr
      border: none
      border-top: 2px solid rgba(13, 13, 13, 0.1)
      margin: 2rem 0

    p.is-editor-empty:first-child::before
      content: attr(data-placeholder)
      float: left
      color: #adb5bd
      pointer-events: none
      height: 0

    table
      border-collapse: collapse
      table-layout: fixed
      width: 100%
      margin: 0
      overflow: hidden

      td, th
        min-width: 1em
        border: 2px solid #ced4da
        padding: 3px 5px
        vertical-align: top
        box-sizing: border-box
        position: relative

      td > *
        margin-bottom: 0

      th
        > *
          margin-bottom: 0

        font-weight: bold
        text-align: left
        background-color: #f1f3f5

      .selectedCell:after
        z-index: 2
        position: absolute
        content: ""
        left: 0
        right: 0
        top: 0
        bottom: 0
        background: rgba(200, 200, 255, 0.4)
        pointer-events: none

      .column-resize-handle
        position: absolute
        right: -2px
        top: 0
        bottom: -2px
        width: 4px
        background-color: #adf
        pointer-events: none

      p
        margin: 0

  .tableWrapper
    overflow-x: auto

  .resize-cursor
    cursor: ew-resize
    cursor: col-resize

  .mention
    color: #007bff

  .bubble-menu
    min-width: 600px
    background: white
</style>
